import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-window--blue",
  "use": "close-window--blue-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"close-window--blue\"><path d=\"M2.121.707l9.9 9.9 9.9-9.9a1 1 0 011.414 1.414l-9.9 9.9 9.9 9.9a1 1 0 01-1.415 1.414l-9.899-9.9-9.9 9.9A1 1 0 11.707 21.92l9.9-9.899-9.9-9.9A1 1 0 112.121.707z\" fill=\"#003595\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol